import { ReactElement } from "react";
import DriverLocationList from "../../components/Driver/LocationHistory";
import Layout from "../../components/layout";

const DriverLocationHistoryPage = (): ReactElement => {
  return (
    <Layout>
      <DriverLocationList />
    </Layout>
  );
};

export default DriverLocationHistoryPage;
